export default "__VITE_PUBLIC_ASSET__9093f59f__"